import { DsLinearWorkInterface } from '../interfaces/ds-linear-work.interface';
import { DsLinearWorkTypesEnum } from '../enums/ds-linear-work-types.enum';

export class DsLinearWork {
  /**
   *
   */
  public id: number | null = null;

  /**
   *
   */
  public name: string | null = '';

  /**
   *
   */
  public startKp: number | null = null;

  /**
   *
   */
  public endKp: number | null = null;

  /**
   *
   */
  public attachmentKp: number | null = null;

  /**
   *
   */
  public type: DsLinearWorkTypesEnum;

  /**
   *
   */
  public createddate: number | null = null;

  /**
   *
   */
  public updateddate: number | null = null;

  /**
   *
   */
  public createdby: number | null = null;

  /**
   *
   */
  public parentId: number | null = null;

  /**
   *
   */
  public planId: number | null = null;

  /**
   * Previous work can be provided when editing/deleting
   */
  public previousWork?: DsLinearWork;

  /**
   * Next work can be provided when editing/deleting
   */
  public nextWork?: DsLinearWork;

  /**
   * (Optional) List of children works.
   */
  public works?: DsLinearWork[];

  /**
   * Creates an instance of DsLinearWork.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsLinearWorkInterface = {}) {
    this.id = jsonData.id || this.id;
    this.name = jsonData.name || this.name;
    this.startKp = jsonData.start_pk || this.startKp;
    // start kp can be equal to 0
    if (jsonData.start_pk === 0) {
      this.startKp = 0;
    }
    // end kp cannot be equal to 0
    this.endKp = jsonData.end_pk || this.endKp;
    this.attachmentKp = jsonData.attachment_pk || this.attachmentKp;
    // attachment kp can be equal to 0
    if (jsonData.attachment_pk === 0) {
      this.attachmentKp = 0;
    }
    this.type = jsonData.type || this.type;
    this.createddate = jsonData.createddate || this.createddate;
    this.updateddate = jsonData.updateddate || this.updateddate;
    this.createdby = jsonData.createdby || this.createdby;
    this.parentId = jsonData.parent_id || this.parentId;
    this.planId = jsonData.plan_id || this.planId;
    this.previousWork = jsonData.previousWork ? new DsLinearWork(jsonData.previousWork) : this.previousWork;
    this.nextWork = jsonData.nextWork ? new DsLinearWork(jsonData.nextWork) : this.nextWork;
    this.works = jsonData.works ? jsonData.works.map((work) => new DsLinearWork(work)) : this.works;
  }
}
